import { render, staticRenderFns } from "./Fedex.vue?vue&type=template&id=a6f2bdba&scoped=true"
import script from "./Fedex.vue?vue&type=script&lang=js"
export * from "./Fedex.vue?vue&type=script&lang=js"
import style0 from "./Fedex.vue?vue&type=style&index=0&id=a6f2bdba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f2bdba",
  null
  
)

export default component.exports